export default __webpack_public_path__ + "static/media/message.d9ed53b2.svg";